// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1OJNC","modalForm":"UpgradeEpcsModal_modalForm__1I3Lc","modalFooter":"UpgradeEpcsModal_modalFooter__14zUP"};